export const whatsappNumber = 'WhatsApp: +905318598240';